import React, { useState, useEffect } from 'react';
import { Form, Input, Row, Col, InputNumber, Select, message } from 'antd';
import supplyChainService, { Supplier } from '../../services/supplyChainService';

const { Option } = Select;

export const SKUFormSupplyChainFields: React.FC = () => {
    const form = Form.useFormInstance();
    const [suppliers, setSuppliers] = useState<Supplier[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchSuppliers = async () => {
            setLoading(true);
            try {
                const res = await supplyChainService.getSuppliers({ page_size: 1000 });
                const data = res.data as any;
                setSuppliers(Array.isArray(data) ? data : data?.results || []);
            } catch (error) {
                console.error('Failed to load suppliers', error);
                message.error('加载供应商列表失败');
            } finally {
                setLoading(false);
            }
        };

        fetchSuppliers();
    }, []);

    return (
        <div style={{ marginTop: 12 }}>
            <Row gutter={16}>
                <Col span={6}>
                    <Form.Item name="supplier_name" label="供应商名称" style={{ marginBottom: 12 }}>
                        <Select
                            placeholder="选择供应商"
                            showSearch
                            allowClear
                            loading={loading}
                            optionFilterProp="children"
                            onChange={(value) => {
                                // value will be the supplier NAME because of how we map Options
                                const supplier = suppliers.find(s => s.name === value);
                                if (supplier) {
                                    form.setFieldsValue({
                                        supplier_link: supplier.link,
                                        supplier_contact: supplier.contact_name,
                                        supplier_phone: supplier.phone,
                                        supplier_address: supplier.address,
                                        lead_time_days: supplier.lead_time_days,
                                    });
                                } else {
                                    // Cleared
                                    form.setFieldsValue({
                                        supplier_link: '',
                                        supplier_contact: '',
                                        supplier_phone: '',
                                        supplier_address: '',
                                        lead_time_days: null,
                                    });
                                }
                            }}
                        >
                            {suppliers.map(supplier => (
                                <Option key={supplier.id} value={supplier.name}>
                                    {supplier.name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item name="supplier_link" label="供应商链接" style={{ marginBottom: 12 }}>
                        <Input placeholder="例如: 1688链接" />
                    </Form.Item>
                </Col>
                <Col span={4}>
                    <Form.Item name="supplier_contact" label="联系人" style={{ marginBottom: 12 }}>
                        <Input placeholder="姓名" />
                    </Form.Item>
                </Col>
                <Col span={4}>
                    <Form.Item name="supplier_phone" label="联系电话" style={{ marginBottom: 12 }}>
                        <Input placeholder="电话/微信" />
                    </Form.Item>
                </Col>
                <Col span={4}>
                    <Form.Item name="supplier_sku" label="工厂货号" style={{ marginBottom: 12 }}>
                        <Input placeholder="工厂型号" />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item name="supplier_address" label="供应商地址" style={{ marginBottom: 12 }}>
                        <Input placeholder="工厂/发货地址" />
                    </Form.Item>
                </Col>
                <Col span={3}>
                    <Form.Item name="purchaser" label="采购员" style={{ marginBottom: 12 }}>
                        <Input placeholder="采购" />
                    </Form.Item>
                </Col>
                <Col span={3}>
                    <Form.Item name="developer" label="开发员" style={{ marginBottom: 12 }}>
                        <Input placeholder="开发" />
                    </Form.Item>
                </Col>
                <Col span={3}>
                    <Form.Item name="moq" label="起订量" style={{ marginBottom: 12 }}>
                        <InputNumber style={{ width: '100%' }} min={1} precision={0} placeholder="MOQ" />
                    </Form.Item>
                </Col>
                <Col span={3}>
                    <Form.Item name="lead_time_days" label="交期(天)" style={{ marginBottom: 12 }}>
                        <InputNumber style={{ width: '100%' }} min={1} precision={0} />
                    </Form.Item>
                </Col>
            </Row>
        </div>
    );
};
